<template>
  <b-row :align-h="position">
    <div class="page-total">
      <b-button variant="link" :size="size" disabled
        >{{ $l('INDEX.label_pagination_total') }} {{ pageTotal }}
        {{ $l('INDEX.label_pagination_records') }}</b-button
      >
    </div>
    <div class="page-size">
      <b-form-select
        v-model="pageSize"
        :size="size"
        :options="pageSizes"
        @change="handleSizeChange"
      ></b-form-select>
    </div>
    <b-pagination
      ref="pagination"
      class="ml-3"
      v-model="currentPage"
      :per-page="pageSize"
      :total-rows="pageTotal"
      :size="size"
      @change="handleCurrentChange"
    ></b-pagination>
    <div class="page-goto">
      <b-input-group
        :size="size"
        :prepend="$l('INDEX.label_pagination_go')"
        :append="$l('INDEX.label_pagination_page')"
      >
        <b-form-input
          class="text-center"
          type="text"
          :formatter="formatter"
          v-model="to"
          @blur="goto"
          @keyup.enter="goto"
        />
      </b-input-group>
    </div>
  </b-row>
</template>
<script>
export default {
  props: {
    currentPage: {
      default: 0,
    },
    pageSize: {
      default: 0,
    },
    pageTotal: {
      default: 0,
    },
    pageSizes: {
      type: Array,
      default: () => [5, 10, 15, 20, 50, 100],
    },
    size: {
      type: String,
      default: 'sm',
    },
    align: {
      type: String,
      default: 'right',
    },
  },
  data() {
    return {
      to: this.currentPage,
    }
  },
  computed: {
    position() {
      let p = this.align
      switch (this.align) {
        case 'left':
          p = 'start'
          break
        case 'right':
          p = 'end'
          break
      }
      return p
    },
  },
  methods: {
    formatter(val) {
      if (val) {
        return val.replace(/[^\d]/g, '')
      }
      return val
    },
    goto() {
      let to = this.to
      let pages = this.$refs.pagination.pageSizeNumberOfPages.numberOfPages
      if (pages < 1 || this.currentPage === to) {
        return
      }
      if (to > pages) {
        to = pages
      }
      if (to < 1) {
        to = 1
      }
      this.handleCurrentChange(to)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.$emit('change', {
        current: this.currentPage,
        size: val,
        total: this.pageTotal,
      })
    },
    handleCurrentChange(val) {
      this.to = val
      this.$emit('change', {
        current: val,
        size: this.pageSize,
        total: this.pageTotal,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.page-total {
  .btn-link:disabled,
  .btn-link.disabled {
    color: #606266;
  }
  .btn {
    font-size: 14px;
  }
}
.page-size {
  min-width: 80px;
  max-width: 100px;
}
.page-goto {
  .input-group-text {
    color: #939393;
    background-color: transparent;
    border: 0;
    font-size: 14px;
  }
  .form-control {
    max-width: 60px;
    border-radius: 0.25rem;
  }
  span {
    margin: auto 0;
  }
}
</style>
